import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@1trading/react/components/ui/card';
import { cn } from '@1trading/react/lib/utils';
import React from 'react';

const LinkCard = React.forwardRef<React.ElementRef<typeof Card>, Omit<React.ComponentPropsWithoutRef<typeof Card>, 'bordered' | 'size'>>(
  ({ children, className, ...props }, ref) => (
    <Card ref={ref} className={cn('flex items-center gap-6 md:gap-8 md:block md:text-center -md:shadow-none', className)} size="lg" bordered {...props}>
      {children}
    </Card>
  ),
);
LinkCard.displayName = 'LinkCard';

const LinkCardHeader = React.forwardRef<React.ElementRef<typeof CardHeader>, React.ComponentPropsWithoutRef<typeof CardHeader>>(({ children, className, ...props }, ref) => (
  <CardHeader ref={ref} className={cn('-md:p-6 -md:pr-0', className)} {...props}>
    {children}
  </CardHeader>
));
LinkCardHeader.displayName = 'LinkCardHeader';

const LinkCardContent = React.forwardRef<React.ElementRef<typeof CardContent>, React.ComponentPropsWithoutRef<typeof CardContent>>(({ children, className, ...props }, ref) => (
  <CardContent ref={ref} className={cn('-md:flex-1 space-y-2 -md:p-6 -md:pl-0', className)} {...props}>
    {children}
  </CardContent>
));
LinkCardContent.displayName = 'LinkCardContent';

const LinkCardDescription = React.forwardRef<React.ElementRef<typeof CardDescription>, React.ComponentPropsWithoutRef<typeof CardDescription>>(
  ({ children, className, ...props }, ref) => (
    <CardDescription ref={ref} className={cn('-md:hidden md:mt-2', className)} {...props}>
      {children}
    </CardDescription>
  ),
);
LinkCardDescription.displayName = 'LinkCardDescription';

const LinkCardTitle = React.forwardRef<React.ElementRef<typeof CardTitle>, React.ComponentPropsWithoutRef<typeof CardTitle>>(({ children, className, ...props }, ref) => (
  <CardTitle ref={ref} className={cn('text-base md:text-2xl md:leading-tight', className)} {...props}>
    {children}
  </CardTitle>
));
LinkCardTitle.displayName = 'LinkCardTitle';

export { LinkCard, LinkCardContent, LinkCardDescription, LinkCardHeader, LinkCardTitle };
